module.exports = __webpack_public_path__ + "static/media/purchase-steps-2.1a6c3484.svg";